import type React from "react";
import { useText } from "../../hooks/lang";
import { tw } from "../../styling";
import type { LangKey } from "../../types/lang";
import { SvgIcon } from "../svg-icon";

type Props = {
	children: string | LangKey | undefined;
	error?: boolean;
	align?: "left" | "right";
	id?: string;
};

const textClasses = tw`font-default text-text-secondary flex w-full items-center gap-2 pl-2 text-left text-xs`;

export const FormHelperText: React.FC<Props> = ({
	children,
	error = false,
	align = "left",
	id,
}) => {
	const [t] = useText();

	if (!children) return null;

	const getText = (e: string | LangKey) => (typeof e === "string" ? e : t(e));

	return (
		<span
			id={id}
			role={error ? "alert" : undefined}
			className={tw(textClasses, error && "text-text-error", align === "right" && "text-right")}
		>
			{error && <SvgIcon imageSrc="ALERT" />}
			{getText(children)}
		</span>
	);
};
